// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"62818e3f2dc1ffc1b71d","691":"f8c274cf25ac76c24aed"}[chunkId] + ".js";
};